import { ObjectRule } from '@/classes/rules/ObjectRule';
import { DefaultValue } from '@/classes/rules/DefaultValue';
import { ScenarioExt } from '@/classes/scenario/ScenarioExt';
import { InjectionModelRef } from '@/dto/scenario/ScenarioReference';
import { ProjectTypeRef } from '@/dto/scenario/ProjectReference';
import { ScenarioRenFrWindExt } from '@/classes/scenario/ren-fr/wind/ScenarioRenFrWindExt';
import { MinMaxRule } from '@/classes/rules/MinMaxRule';
import { EnumRule } from '@/classes/rules/EnumRule';
import { TurbineEnum } from '@/dto/scenario/ren-fr/wind/WindReference';

export const buildRenFrWindRules = () => new ObjectRule<ScenarioRenFrWindExt>('ren_fr_wind', [
  new MinMaxRule('numberOfTurbineType1'),
  new EnumRule('turbineModelType1', TurbineEnum),
  new MinMaxRule('unitPowerOfTurbineType1'),
  new MinMaxRule('rotorDiameterType1'),
  new MinMaxRule('numberOfTurbineType2'),
  new EnumRule('turbineModelType2', TurbineEnum)
    .withDefaultValue(() => new DefaultValue('')),
  new MinMaxRule('unitPowerOfTurbineType2'),
  new MinMaxRule('rotorDiameterType2'),

  new MinMaxRule('net_p50'),
  new MinMaxRule('net_p90'),
  new MinMaxRule('numberOfPdl'),
  new MinMaxRule('numberOfPdlPtr'),
  new MinMaxRule('numberOfPtr')
])
  .withIsAvailable(scenario => isRenFranceWindProject(scenario))
  .withDefaultValue(() => new DefaultValue(new ScenarioRenFrWindExt()));

function isRenFranceWindProject(scenario: ScenarioExt): boolean {
  return (scenario.project?.typeRef === ProjectTypeRef.ren_fr_wind_project) &&
    scenario.hasInjectionType(InjectionModelRef.total_injection);
}
